<template>
  <fb-form-body>
    <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="fb-form">

<!--      <el-form-item :label="$t('lang.编号') + '：'" prop="number">
        <el-select v-model="formData.number">
          <el-option v-for="i in 30" :key="i" :label="i" :value="i"></el-option>
        </el-select>
      </el-form-item>-->

      <el-form-item :label="$t('lang.标签名称') + '：'" prop="tagName">
        <nation-input v-model="formData.recipeTagLang" />
      </el-form-item>

      <el-form-item :label="$t('lang.主语言') + '：'" prop="lang" >
        <el-radio-group v-model="formData.lang" style="min-width: 800px">
          <el-row :gutter="24">
            <el-col :span="6" v-for="lang in langList" :key="lang.value + '_key'" >
              <el-radio :label="lang.value">{{ lang.name }}（{{ lang.value }}）</el-radio>
            </el-col>
          </el-row>
        </el-radio-group>
      </el-form-item>

      <el-form-item :label="$t('lang.是否在机器显示')">
        <el-switch v-model="formData.show" inactive-value="N" active-value="Y" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit('form')">{{ $t('lang.确定') }}</el-button>
        <el-button @click="handleReset('form')">{{ $t('lang.重置') }}</el-button>
      </el-form-item>
    </el-form>
  </fb-form-body>
</template>

<script>
import {handleFilterLang} from "../../utlis/utlis";
import {loadSysSettLang, loadTagsByLang} from "../../js/common";
import NationInput from "../../components/nation/NationInput";
export default {
  name: "FittingAdd",
  components: {NationInput },
  data() {
    return {
      api: {
        add: this.$api.recipeTag.add
      },
      formErrorMsg: {account: ''},
      formData: {
        number: '',
        lang: '',
        brandOwnerCode: '',
        recipeTagLang: {},
        show: "Y",
      },
      langRadio: '',
    }

  },
  computed: {
    rules() {
      return {
        number: [
          {required: true, message: this.$t('lang.序号不能为空'), trigger: 'blur'}
        ],
        lang: [
          {required: true, message: this.$t('lang.主语言不能为空'), trigger: 'blur'}
        ],
      }
    },
    langList() {
      return handleFilterLang(this);
    }
  },
  methods: {
    handleSubmit(form) {

      let vm = this;
      vm.$refs[form].validate((valid) => {
        if (valid) {
          let data = {...vm.formData}
          let langList = data['recipeTagLang']
          if(Object.keys(langList).length == 0) {
            vm.$message.error(vm.$t('lang.标签名称未输入'));
            return;
          }
          data['recipeTagLang'] = {}
          for (const key in langList) {
            // 校验主语言是否输入
            if(!langList[data['lang']]) {
              vm.$message.error(vm.$t('lang.主语言分类名称不能为空'));
              return;
            }

            // 过滤
            if(langList[key]) {
              data['recipeTagLang'][key] = langList[key]
            }
          }
          vm.$http.post(vm.api.add, data).then((resp) => {

            if (resp.data.status === 200) {
              vm.$message({
                type: 'success',
                message: resp.data.desc
              });
              loadTagsByLang(this);
              vm.$router.back();
            } else if (resp.data.status === 400) {

              console.log(vm.$refs[form]);


              if (resp.data.desc) {
                vm.$message({
                  type: "error",
                  message: resp.data.desc
                });
              }


            } else {
              vm.$message({
                type: "error",
                message: resp.data.desc
              })
            }

          });
          return true;
        } else {
          return false;
        }
      });

    }
    ,
    handleReset(form) {
      this.$refs[form].resetFields();
      this.formData.recipeTagLang = {}
      this.formData.show = "Y";
    }
  },
  async created() {
    await loadSysSettLang(this);
    this.formData.brandOwnerCode = JSON.parse(sessionStorage.getItem("login-user-info")).brandOwnerCode
  },
  watch: {
    langList: {
      handler(list) {
        if(list && list.length) {
          list.forEach(i => {
            this.$set( this.formData['recipeTagLang'], i.value, '');
          });
        }
      },
      immediate: true,
    }
  }
}
</script>

<style scoped>

.fb-form {
  max-width: 500px;
}


.lang-box {
  display: flex;
  margin-top: 14px;
}

/deep/ .el-radio {
  line-height: 40px;
}

</style>
